export default {
  stepCounterItems: [],
  activeStepIndex: 0
}
